import React from 'react'
import PropTypes from 'prop-types'
import './RadioButton.scss'
import HrbTranslate from '../../../language/HrbTranslate';
import { FormControl, RadioGroup } from '@mui/material';
import RadioButton from './RadioButton';
import classNames from 'classnames';

const RadioButtonGroup = props => {
    const {elementId, name, groupLabel, groupLabelClassName, children, labelName, defaultValue } = props;

    return (
        <FormControl>
            {(groupLabel != undefined) && <HrbTranslate className={classNames('rb-group-label', 'p2', {groupLabelClassName: groupLabelClassName })} text={groupLabel} />}
            <RadioGroup
                className='rb-group'
                id={elementId}
                aria-labelledby={labelName}
                defaultValue={defaultValue ?? null}
                name={name} >
                {children}
            </RadioGroup>
        </FormControl>
    )
}

RadioButtonGroup.propTypes = {
    elementId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    groupLabel: PropTypes.string,
    groupLabelClassName: PropTypes.string,
    children: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([RadioButton])
    }),
  ).isRequired,
  labelName: PropTypes.string,
  defaultValue: PropTypes.string,
}

export default RadioButtonGroup

